import React from 'react';
import DOMPurify from 'dompurify';
import styles from './Contact.module.css';

import deck1 from '../assets/images/deck1.webp';
import deck2 from '../assets/images/deck2.webp';
import deck3 from '../assets/images/deck3.webp';
import deck4 from '../assets/images/deck4.webp';
import deck5 from '../assets/images/deck5.webp';
import deck6 from '../assets/images/deck6.webp';
import deck7 from '../assets/images/deck7.webp';
import deck8 from '../assets/images/deck8.webp';
import deck9 from '../assets/images/deck9.webp';

const deckImages = [deck1, deck2, deck3, deck4, deck5, deck6, deck7, deck8, deck9];

const StepTwo = ({ formData, handleInputChange, handleFileChange, errors }) => {
  
  const handleSanitizedInputChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value);
    handleInputChange({
      target: {
        name: e.target.name,
        value: sanitizedValue,
      },
    });
  };

  const handleSanitizedFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileChange(e);
    }
  };

  return (
    <div className={styles.step}>
      <h2>Step 2: Select Your Deck</h2>

      <fieldset className={styles.deckChoiceContainer}>
        <legend className={styles.deckChoiceTitle}>Select your deck or the mirror of your deck</legend>
        <div className={styles.deckOptions}>
          {deckImages.map((deckImage, index) => {
            const deckNumber = `Deck ${index + 1}`;
            return (
              <label key={deckNumber}>
                <input
                  type="radio"
                  className={styles.hiddenRadio}
                  name="deckChoice"
                  value={deckNumber}
                  checked={formData.deckChoice === deckNumber}
                  onChange={handleSanitizedInputChange}
                />
                <img src={deckImage} alt={`Deck ${index + 1}`} />
              </label>
            );
          })}
        </div>
      </fieldset>

      <div className={styles.orDivider}>
        <span>OR</span>
      </div>

      <div
        className={`${styles.customDrawingOption} ${formData.deckChoice === 'custom' ? styles.selected : ''}`}
        role="button"
        tabIndex={0}
        onKeyUp={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            document.getElementById('customDrawing').click();
            handleSanitizedInputChange({ target: { name: 'deckChoice', value: 'custom' } });
          }
        }}
        aria-pressed={formData.deckChoice === 'custom'}
      >
        <div 
          className={`${styles.uploadButton} ${formData.customDrawing ? styles.hasFile : ''}`}
          onClick={() => {
            if (!formData.customDrawing) {
              document.getElementById('customDrawing').click();
            }
            handleSanitizedInputChange({ target: { name: 'deckChoice', value: 'custom' } });
          }}
        >
          {formData.customDrawing ? (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={styles.fileIcon}>
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <span className={styles.fileName}>{formData.customDrawing.name}</span>
              <button 
                type="button" 
                className={styles.removeButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSanitizedInputChange({ target: { name: 'customDrawing', value: null } });
                  document.getElementById('customDrawing').value = '';
                }}
                aria-label="Remove file"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <span>Upload your own drawing (Max 10 MB)</span>
            </>
          )}
        </div>
        <div className={styles.fileInputContainer}>
          <input
            type="file"
            id="customDrawing"
            onChange={handleSanitizedFileChange}
            className={styles.fileInput}
            aria-describedby={errors.customDrawing || errors.fileSize ? 'fileSizeError' : undefined}
            style={{ display: 'none' }}
          />
        </div>
      </div>

      {errors.deckChoice && <p className={styles.error} id="deckChoiceError">{errors.deckChoice}</p>}
      {errors.customDrawing && <p className={styles.error} id="customDrawingError">{errors.customDrawing}</p>}
      {errors.fileSize && <p className={styles.error} id="fileSizeError">{errors.fileSize}</p>}
    </div>
  );
};

export default StepTwo;